<template>
  <div class="Audits px-4">
    <v-container>
      <div class="AuditsHeader my-3">
        <v-row class="headerCaption" align-start justify="space-between">
          <v-col cols="12" class="pa-0 py-2 text-center text-md-left fill-height overflow-hidden">
            <span class="headline">{{ $t('Audits.Header.audits', [demoOrgName]) }}</span>
          </v-col>
        </v-row>
      </div>

      <v-divider />

      <div v-if="showAuditsMainLoading" class="display-1 text-center mt-5">
        <v-progress-circular
          indeterminate
          color="#0098E1"
        />
      </div>

      <template v-else-if="isDesktopView">
        <v-container
          v-if="!hasCardsToDisplay"
          fluid
          class="display-1 text-center grey--text"
        >
          {{ $t('Audits.noAudits') }}
        </v-container>
        <template v-else>
          <MainCard
            v-for="device in demoDevices"
            :key="`demo-${device.id}`"
            :id="`${device.id}-main-card`"
            :deviceData="device"
            :auditData="auditsData.find(audit => audit.device && audit.device.id === device.id)"
            :flowMeasurementData="flowMeasurementsData.find(flowMeasurement => flowMeasurement.device && flowMeasurement.device.id === device.id)"
            :pluviometricChartData="pluviometricChartsData.find(pluviometricChart => pluviometricChart.device && pluviometricChart.device.id === device.id)"
            :uniformityData="uniformitiesData.find(uniformity => uniformity.device && uniformity.device.id === device.id)"
          />
        </template>
      </template>

      <v-container
        v-else
        fluid
        class="text-center mt-5 pa-5"
      >
        <v-icon size="45" color="#00202F" class="mb-4">mdi-monitor</v-icon>
        <p class="mobile-title-text mb-2">No disponible en móvil</p>
        <p class="mobile-subtitle-text">Debe acceder desde una computadora para ver este informe correctamente. La versión móvil estará disponible pronto.</p>
      </v-container>
    </v-container>
  </div>
</template>

<script>
import MainCard from './MainCard'
import {
  getAuditsListQuery,
  getFlowMeasurementsListQuery,
  getPluviometricChartsListQuery,
  getUniformitiesListQuery
} from '@/lib/auditsQueries'

export default {
  components: {
    MainCard
  },
  data () {
    return {
      auditsData: [],
      flowMeasurementsData: [],
      pluviometricChartsData: [],
      uniformitiesData: [],
      windowWidth: window.innerWidth
    }
  },
  computed: {
    demoOrgName () {
      return 'Demo'
    },
    isDesktopView () {
      return this.windowWidth >= 910
    },
    showAuditsMainLoading () {
      const q = this.$apollo.queries
      return Boolean(
        (q.auditsData && q.auditsData.loading) ||
        (q.flowMeasurementsData && q.flowMeasurementsData.loading) ||
        (q.pluviometricChartsData && q.pluviometricChartsData.loading) ||
        (q.uniformitiesData && q.uniformitiesData.loading)
      )
    },
    demoDevices () {
      const devicesMap = new Map()
      const upsert = (item, key) => {
        if (!item || !item.device || !item.device.id) return
        const deviceId = item.device.id
        if (!devicesMap.has(deviceId)) {
          devicesMap.set(deviceId, {
            id: item.device.id,
            name: item.device.name,
            audits: [],
            flowMeasurements: [],
            pluviometricCharts: [],
            uniformitys: []
          })
        }
        devicesMap.get(deviceId)[key].push(item)
      }

      this.auditsData.forEach((item) => upsert(item, 'audits'))
      this.flowMeasurementsData.forEach((item) => upsert(item, 'flowMeasurements'))
      this.pluviometricChartsData.forEach((item) => upsert(item, 'pluviometricCharts'))
      this.uniformitiesData.forEach((item) => upsert(item, 'uniformitys'))

      return Array.from(devicesMap.values()).sort((a, b) => a.name.localeCompare(b.name))
    },
    hasCardsToDisplay () {
      return this.demoDevices.length > 0
    }
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  },
  apollo: {
    $client: 'auditsClient',
    auditsData: {
      query: getAuditsListQuery({ includeDealFilter: false, demoOnly: true, publishedOnly: true }),
      update: data => data.audits || []
    },
    flowMeasurementsData: {
      query: getFlowMeasurementsListQuery({ includeDealFilter: false, demoOnly: true, publishedOnly: true }),
      update: data => data.flowMeasurements || []
    },
    pluviometricChartsData: {
      query: getPluviometricChartsListQuery({ includeDealFilter: false, demoOnly: true, publishedOnly: true }),
      update: data => data.pluviometricCharts || []
    },
    uniformitiesData: {
      query: getUniformitiesListQuery({ includeDealFilter: false, demoOnly: true, publishedOnly: true }),
      update: data => data.uniformities || []
    }
  }
}
</script>

<style scoped>
.mobile-title-text {
  font-size: 1.38rem;
  font-weight: 400;
  color: #00202F;
}

.mobile-subtitle-text {
  font-size: 1.12rem;
  font-weight: 300;
  color: #00202F;
}
</style>



// WEBPACK FOOTER //
// AuditsDemo.vue?691858cf